import api from './api'

const URL = '/api/orderService'
let service = {}

service.createOrder = function (data) {
  return api.post(`${URL}/v2/createOrderExistClient`, data).then(res => res.data)
}

export default service
